export class ApplicationAgentDetails {
    GivenName: string;
    FamilyName: string;
    PhoneCountryCode: string;
    PhoneNumber: string;
    EmailAddress: string;
    AdditionalInformation: string;
}